import { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { TextField, Button, Collapse, Toggle } from '../../cdl-react-components/components'
import { setConfiguration } from '../../../store/actions'
import { updateSearchParameters } from '../../../store/actions/search'
import { clearObject, contains, graphqlFetch, onDesktop } from '../../cdl-react-components/utilities'
import { SearchParameter } from '../../../utilities/models'
import CheckboxSearch from './CheckboxSearch'
import ContentTypes from './ContentTypes'
import LocationSearch from './LocationSearch'
import SearchInput from './SearchInput'

class Search extends Component {
    state = {
        searchId: -1,
        callbackCounter: 0,
        articleTypes: [],
        mapTypes: [],
        ages: [],
        keyword: '',
        contentTypes: {
            articles: true,
            activityMaps: true,
            regionalMaps: true
        },
        comingSoon: true
    }

    handleChange = (property, value, callback) => this.setState({ [property]: value }, callback)
    handleInputChange = property => e => this.handleChange(property, e.target.value)
    handleCheckboxChange = property => id => e => this.setState({ [property]: { ...this.state[property], [id]: e.target.checked } })
    handelContentTypeChange = property => e => this.setState({ contentTypes: { ...this.state.contentTypes, [property]: e.target.checked }})
    handleSearchButtonPress = () => {
        this.search()
        if(!onDesktop())
            this.props.onComplete()
    }

    searchDisabled = () => !this.state.contentTypes.articles && !this.state.contentTypes.activityMaps && !this.state.contentTypes.regionalMaps

    search = (e) => {
        e && e.preventDefault()

        if (!this.searchDisabled()) {
            let params = []
    
            if (!this.state.comingSoon)
                params.push(new SearchParameter('excludeComingSoon', true))
            else
                params = params.filter(x => x.name !== 'excludeComingSoon')

            if (this.state.keyword)
                params.push(new SearchParameter('keyword', encodeURIComponent(this.state.keyword)))
                
            if (this.state.startDate || this.state.endDate)
                params.push(new SearchParameter('date', [this.state.startDate, this.state.endDate]))
                
            const location = this.child.getLocationValue()
            const locationHasValue = this.child.hasValue()
            /* DEV NOTE: this is awful, literally disgusting to look at. But this whole search is a mess 
               and this is the quickest way to not have unsued location values pulled into the searchParameters.
               Don't keep this if you're every doing a big refactor in here. - rrogers 2026-02-18 */
            if (locationHasValue && location.type === 'dls') {
                if (!!location.townshipStart || !!location.townshipEnd)
                    params.push(new SearchParameter('township', [location.townshipStart, location.townshipEnd]))
                if (!!location.rangeStart || !!location.rangeEnd)
                    params.push(new SearchParameter('range', [location.rangeStart, location.rangeEnd]))
                if (!!location.meridianStart || !!location.meridianEnd)
                    params.push(new SearchParameter('meridian', [location.meridianStart, location.meridianEnd]))
            }
            else if (locationHasValue && location.type === 'nts') {
                if (!!location.blockStart || !!location.blockEnd)
                    params.push(new SearchParameter('block', [location.blockStart, location.blockEnd]))
                if (!!location.subdivisionStart || !!location.subdivisionEnd)
                    params.push(new SearchParameter('subdivision', [location.subdivisionStart, location.subdivisionEnd]))
                if (!!location.mapUnitStart || !!location.mapUnitEnd)
                    params.push(new SearchParameter('mapUnit', [location.mapUnitStart, location.mapUnitEnd]))
                if (!!location.quadStart || !!location.quadEnd)
                    params.push(new SearchParameter('quad', [location.quadStart, location.quadEnd]))
            }

            const allArticleTypes = 
                this.state.articleTypes.length === 0 ||
                this.state.articleTypes.length === this.props.articleTypes.length
            if (!allArticleTypes)
                params.push(new SearchParameter('articleTypes', this.state.articleTypes))
    
            const allMapTypes = 
                this.state.mapTypes.length === 0 ||
                this.state.mapTypes.length === this.props.mapTypes.length
            if (!allMapTypes)
                params.push(new SearchParameter('mapTypes', this.state.mapTypes))

            const allAges = 
                this.state.ages.length === 0 ||
                this.state.ages.length === this.props.ages.length
            if (!allAges)
                params.push(new SearchParameter('ages', this.state.ages))
    
            const contentTypes = Object.keys(this.state.contentTypes).filter(key => this.state.contentTypes[key])
            if (contentTypes.length !== Object.keys(this.state.contentTypes).length)
                params.push(new SearchParameter('contentTypes', contentTypes))
            
            this.props.updateSearchParameters(params)
        }
        // Else { the search is disabled, don't run the search }
    }

    reset = () => {
        const defaultValues = {
            articleTypes: this.props.articleTypes.map(x => x.id.toString()),
            mapTypes: this.props.mapTypes.map(x => x.id.toString()),
            ages: this.props.ages.map(x => x.id.toString()),
            contentTypes: {
                articles: true,
                activityMaps: true,
                regionalMaps: true
            },
            comingSoon: true,
            searchId: this.props.searchId
        }

        // have to set the state values to '' to clear the inputs before removing them all together - rrogers 2018-07-17
        this.setState({ 
            ...clearObject(this.state, ''),
            ...defaultValues
        }, () => {
            this.setState({
                ...clearObject(this.state),
                ...defaultValues
            }, () => this.child.reset(this.search))
        })
    }

    parseParametersToState = (params, callback = () => {}) => {
        if (params) {
            const pullValue = name => {
                const item = params.find(x => x.name === name)
                return item ? item.value : undefined
            }

            const keyword = decodeURIComponent(pullValue('keyword') || '')
            const date = pullValue('date') || [undefined, undefined]
            const articleTypes = pullValue('articleTypes')
            const comingSoon = !pullValue('excludeComingSoon')

            const mapTypes = pullValue('mapTypes')
            const ages = pullValue('ages')
            const contentTypeValues = pullValue('contentTypes')
            const contentTypes = {
                articles: !contentTypeValues || contains(contentTypeValues, 'articles'),
                activityMaps: !contentTypeValues || contains(contentTypeValues, 'activityMaps'),
                regionalMaps: !contentTypeValues || contains(contentTypeValues, 'regionalMaps')
            }

            const newState = {
                keyword,
                contentTypes,
                comingSoon,
                startDate: date[0],
                endDate: date[1],
                searchId: this.props.searchId
            }

            if (articleTypes)
                newState.articleTypes = typeof articleTypes === 'string' ? articleTypes.split(',') : articleTypes
            if (mapTypes)
                newState.mapTypes = typeof mapTypes === 'string' ? mapTypes.split(',') : mapTypes
            if (ages)
                newState.ages = typeof ages === 'string' ? ages.split(',') : ages

            this.setState(
                newState,
                () => this.child.parseSearchParamsToState(params, callback))
        }
        // Else { no params to parse }
    }

    renderCheckbox = (group, id, disabled) => {
        const item = this.props[group].find(x => x.id === id)
        return (
            <Fragment key={`checkbox-${group}-${id}`}>
                <Toggle
                    type="checkbox"
                    onChange={this.handleCheckboxChange(group)(id)}
                    checked={typeof this.state[group][id] === 'undefined' ? true : this.state[group][id]}
                    disabled={disabled}>
                        {item.name}
                </Toggle><br/>
            </Fragment>)
    }

    render() {
        return (
            <div className="search">
                <form onSubmit={this.search}>
                    <div className="search__container">
                        <SearchInput 
                            value={this.state.keyword} 
                            onChange={this.handleInputChange('keyword')} 
                            onSearch={this.handleSearchButtonPress}/>
                        <Toggle
                            type="switch"
                            onChange={(e) => this.setState({ comingSoon: e.target.checked })}
                            checked={this.state.comingSoon}>
                                Coming Soon
                        </Toggle>
                    </div>
                    <ContentTypes 
                        contentTypes={this.state.contentTypes}
                        handelContentTypeChange={this.handelContentTypeChange} />
                    <Collapse title="Map Type">
                        <CheckboxSearch
                            group="map-type"
                            items={this.props.mapTypes || []}
                            value={this.state.mapTypes || []}
                            onChange={mapTypes => this.setState({ mapTypes })}
                            disabled={!this.state.contentTypes.regionalMaps} />
                    </Collapse>
                    <Collapse title="Topic">
                        <CheckboxSearch
                            group="article-type"
                            items={this.props.articleTypes || []}
                            value={this.state.articleTypes || []}
                            onChange={articleTypes => this.setState({ articleTypes })}
                            disabled={!this.state.contentTypes.articles} />
                    </Collapse>
                    <Collapse title="Location">
                        <LocationSearch disabled={this.state.contentTypes.articles} onRef={instance => { this.child = instance }} />
                    </Collapse>
                    <Collapse title="Formation Age">
                        <CheckboxSearch
                            group="ages"
                            items={this.props.ages || []}
                            value={this.state.ages || []}
                            onChange={ages => this.setState({ ages })}
                            disabled={!this.state.contentTypes.articles} />
                    </Collapse>
                    <Collapse title="Publication Date">
                        <TextField 
                            type="date"
                            label="Start Date"
                            placeholder="mm/dd/yyyy" 
                            value={this.state.startDate} 
                            onChange={this.handleInputChange('startDate')}
                        />
                        <TextField 
                            type="date"
                            label="End Date"
                            placeholder="mm/dd/yyyy" 
                            value={this.state.endDate} 
                            onChange={this.handleInputChange('endDate')}
                        />
                    </Collapse>
                </form>
                <div className="search__button-container">
                    <Button className="search__button--reset" onClick={this.reset}>Clear</Button>
                    <Button className="search__button--search" raised onClick={this.handleSearchButtonPress} disabled={this.searchDisabled()}>Search</Button>
                </div>
            </div>
        )
    }

    componentDidMount() {
        const parseResults = property => results => {
            this.props.setConfiguration({ [property]: results })
            if (this.state[property].length === 0)
                this.setState({ [property]: results.map(x => x.id.toString()) })
        }

        graphqlFetch('wcms3', `
            query {
                articleTypes(order: { name: ASC }) {
                    id
                    name
                    articles: contentArticleArticleTypes {
                        id
                    }
                }
                ages(order: { order: ASC }) {
                    id
                    name
                    order
                }
                maptypes(order: { name: ASC }) {
                    id
                    name                    
                }
            }`)
            .then(res => {
                parseResults('articleTypes')(res.data.articleTypes.filter(x => x.articles.length > 0))
                parseResults('ages')(res.data.ages)
                parseResults('mapTypes')(res.data.maptypes)

                // = Run initial search after config values have been set - rrogers 2026-02-18 =
                this.search()
            })
    }

    componentDidUpdate() {
        if (this.props.searchId > this.state.searchId)
            this.parseParametersToState(this.props.parameters)
    }
}

const mapStateToProps = ({data, search}) => {
    const articleTypes =
        (data.configuration && 
         data.configuration.articleTypes) ||
        []
    const ages =
        (data.configuration && 
         data.configuration.ages) ||
        []
    const mapTypes = 
        (data.configuration &&
         data.configuration.mapTypes) ||
        []

    return {
        articleTypes,
        ages,
        mapTypes,
        parameters: search.parameters,
        searchId: search.id
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateSearchParameters: (parameters) => dispatch(updateSearchParameters(parameters)),
        setConfiguration: (configuration) => dispatch(setConfiguration(configuration))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Search)